import { useMemo } from 'react';

import type { ApiEstimationStage } from '@/api/schema/data-contracts';
import { apiEstimationStageMessageDefinitions } from '@/context/localization/enums/messages';
import { useMessages } from '@/hooks/messages';

interface EstimationStageSelectOptions {
  value: ApiEstimationStage;
  label: string;
}

export const useEstimationStageOptions = () => {
  const messages = useMessages(apiEstimationStageMessageDefinitions);

  return useMemo<EstimationStageSelectOptions[]>(
    () => [
      {
        value: 'IN_CREATION',
        label: messages.IN_CREATION(),
      },
      {
        value: 'IN_PROCESS',
        label: messages.IN_PROCESS(),
      },
      {
        value: 'IN_REVIEW',
        label: messages.IN_REVIEW(),
      },
      {
        value: 'APPROVED',
        label: messages.APPROVED(),
      },
    ],
    [messages],
  );
};
